import { PageMeta } from 'constants/pages';
import { ArticleSections } from 'types/articles';

import {
  firstSeptember2025NewsData,
  firstSeptember2025NewsMeta,
} from './first-september-2025-news';

import { aiSummitTurku2025NewsData, aiSummitTurku2025NewsMeta } from './ai-summit-turku-2025-news';

interface NewsParameters {
  pageMeta: PageMeta;
  articleData: ArticleSections[];
}

export const NEWS: NewsParameters[] = [
  {
    pageMeta: firstSeptember2025NewsMeta,
    articleData: firstSeptember2025NewsData,
  },
  {
    pageMeta: aiSummitTurku2025NewsMeta,
    articleData: aiSummitTurku2025NewsData,
  },
];
